import {
  cartOverview,
  type CartOverview,
} from '@/domains/shoppingCart/CartOverview/interfaces/CartOverview';
import { sumCartOverviewQuantities } from '@/domains/shoppingCart/common/utils/sumQuantities';

import { GetCustomerCartOverviewQuery } from '../graphql/generated/cartOverviewQuery.generated';

type CartItems = {
  [key: string]: number;
};

export const formatForCartOverview = (
  apiCartOverview: GetCustomerCartOverviewQuery | null,
): CartOverview => {
  const formattedForCartOverview: CartOverview = cartOverview;
  const findCustomerCartResponse = apiCartOverview?.findCustomerCart;

  const productsTotalPrice =
    apiCartOverview?.computeTotalForCart
      .totalCartPriceToBePaidByTheCustomerVatIncl.amount;

  if (
    !apiCartOverview ||
    !findCustomerCartResponse ||
    Object.keys(findCustomerCartResponse?.items).length === 0
  ) {
    return formattedForCartOverview;
  }

  const overview: CartItems = findCustomerCartResponse.items.reduce(
    (acc: CartItems, item) => {
      const productId = item.product.productId;
      acc[productId] = item.quantity;
      return acc;
    },
    {},
  );

  formattedForCartOverview.contents = overview;

  formattedForCartOverview.productCount = Object.keys(overview).length;

  formattedForCartOverview.itemsCount = sumCartOverviewQuantities(overview);

  formattedForCartOverview.productsTotalPrice = productsTotalPrice || 0;

  return formattedForCartOverview;
};
